import { render, staticRenderFns } from "./Customfields.vue?vue&type=template&id=1f7129e4&"
import script from "./Customfields.vue?vue&type=script&lang=js&"
export * from "./Customfields.vue?vue&type=script&lang=js&"
import style0 from "./Customfields.vue?vue&type=style&index=0&id=1f7129e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports